import React, { useState } from 'react'
import { brandCSS } from '../../brand'
import { FOOTER_CSS } from './footer.css.js'

const base = (window.wpData?.siteUrl ?? '').replace(/\/$/, '')

function IconFacebook() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  )
}

function IconYoutube() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
      <polygon fill="var(--color-midnight)" points="9.75,15.02 15.5,12 9.75,8.98 9.75,15.02"/>
    </svg>
  )
}

function IconInstagram() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
    </svg>
  )
}

function IconPhone() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.59 1.22h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.77A16 16 0 0 0 15 15.84l.91-.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  )
}

function IconMail() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect width="20" height="16" x="2" y="4" rx="2"/>
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
    </svg>
  )
}

function IconMapPin() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
      <circle cx="12" cy="10" r="3"/>
    </svg>
  )
}

const SITE_LOGO = (window.wpData?.siteLogo ?? '').trim()

function IconExternalLink() {
  return (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{ display: 'inline', marginLeft: 4, verticalAlign: 'middle', opacity: 0.55 }}
      aria-hidden="true">
      <path d="M15 3h6v6M10 14 21 3M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
    </svg>
  )
}

function isExternal(href) {
  if (!href || href.startsWith('#') || href.startsWith('/')) return false
  try {
    return new URL(href).hostname !== window.location.hostname
  } catch {
    return false
  }
}

function LogoSVG() {
  if (SITE_LOGO) return <img src={SITE_LOGO} alt="LJN Cruise" className="ft__logo-img" />
  return (
    <svg className="ft__logo-svg" width="160" height="48" viewBox="0 0 160 48">
      <text x="0" y="32"
        fontFamily="'Cormorant Garamond', Georgia, serif"
        fontSize="28" fontWeight="300" letterSpacing="6"
        fill="#F5F2EC">
        LJN
      </text>
      <text x="0" y="46"
        fontFamily="'DM Sans', system-ui, sans-serif"
        fontSize="8" fontWeight="400" letterSpacing="5"
        fill="rgba(201,165,106,0.8)">
        CRUISE &amp; TRAVEL
      </text>
    </svg>
  )
}

const CRUISES_FALLBACK = [
  { label: 'Le Journey Premier',  href: `${base}/cruises/le-journey-premier` },
  { label: 'Le Journey Classic',  href: `${base}/cruises/le-journey-classic` },
  { label: 'Le Journey Deluxe',   href: `${base}/cruises/le-journey-deluxe` },
  { label: 'Day Cruise',          href: `${base}/cruises/day-cruise` },
]

const NAV_INFO_FALLBACK = [
  { label: 'About Us',       href: `${base}/about` },
  { label: 'Travel Guide',   href: `${base}/travel-guide` },
  { label: 'Special Offers', href: `${base}/special-offers` },
  { label: 'Contact Us',     href: `${base}/contact-us` },
]

const OFFICES_FALLBACK = [
  { label: 'Hanoi Office',           address: '18 Tran Hung Dao St, Hoan Kiem, Hanoi',        phone: '+84 24 3933 4949',  email: 'hanoi@ljncruise.com' },
  { label: 'Quảng Ninh Province',    address: 'Tuan Chau Marina, Ha Long Bay, Quảng Ninh',    phone: '+84 203 384 9999' },
  { label: 'Ho Chi Minh City Office',address: '76 Le Lai St, District 1, Ho Chi Minh City',   phone: '+84 28 3822 8888',  email: 'hcm@ljncruise.com' },
]

const wpFooter = window.wpData ?? {}
const CRUISES  = wpFooter.footerCruiseLinks?.length ? wpFooter.footerCruiseLinks : CRUISES_FALLBACK
const NAV_INFO = wpFooter.footerInfoLinks?.length   ? wpFooter.footerInfoLinks   : NAV_INFO_FALLBACK
const OFFICES  = wpFooter.footerOffices?.length     ? wpFooter.footerOffices     : OFFICES_FALLBACK

function SubscribeForm() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    if (!email) return
    setSent(true)
  }

  return (
    <form className="ft__subscribe" onSubmit={handleSubmit}>
      {sent ? (
        <p className="ft__subscribe-thanks">Thank you for subscribing.</p>
      ) : (
        <>
          <input
            type="email"
            className="ft__subscribe-input"
            placeholder="Your email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="ft__subscribe-btn">Subscribe</button>
        </>
      )}
    </form>
  )
}

export default function Footer({ contact = {} }) {
  const year = new Date().getFullYear()
  const facebook = contact.facebook
  const youtube  = contact.youtube

  return (
    <>
      <style>{brandCSS + FOOTER_CSS}</style>
      <footer className="ft">
        <div className="ft__inner">

          {/* ── Row 1: 4 columns ── */}
          <div className="ft__top">

            {/* Col 1: Brand */}
            <div className="ft__brand">
              <a href={`${base}/`} className="ft__logo" aria-label="LJN Cruise">
                <LogoSVG />
              </a>
              <p className="ft__tagline">{contact.description || 'Luxury cruises through the emerald waters of Ha Long Bay.'}</p>
            </div>

            {/* Col 2: Cruises */}
            <div className="ft__col">
              <div className="ft__col-label">Our Cruises</div>
              <ul className="ft__col-links">
                {CRUISES.map(l => {
                  const ext = isExternal(l.href)
                  return (
                    <li key={l.label}>
                      <a href={l.href} target={ext ? '_blank' : undefined} rel={ext ? 'noopener noreferrer' : undefined}>
                        {l.label}{ext && <IconExternalLink />}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>

            {/* Col 3: Information */}
            <div className="ft__col">
              <div className="ft__col-label">Information</div>
              <ul className="ft__col-links">
                {NAV_INFO.map(l => {
                  const ext = isExternal(l.href)
                  return (
                    <li key={l.label}>
                      <a href={l.href} target={ext ? '_blank' : undefined} rel={ext ? 'noopener noreferrer' : undefined}>
                        {l.label}{ext && <IconExternalLink />}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>

            {/* Col 4: Social + Subscribe */}
            <div className="ft__col">
              <div className="ft__col-label">Follow Us</div>
              <div className="ft__social">
                {(facebook || true) && (
                  <a href={facebook || '#'} className="ft__social-link" target="_blank" rel="noopener" aria-label="Facebook">
                    <IconFacebook />
                  </a>
                )}
                {(youtube || true) && (
                  <a href={youtube || '#'} className="ft__social-link" target="_blank" rel="noopener" aria-label="YouTube">
                    <IconYoutube />
                  </a>
                )}
                <a href="#" className="ft__social-link" aria-label="Instagram">
                  <IconInstagram />
                </a>
              </div>
              <div className="ft__col-label" style={{ marginTop: 28 }}>Newsletter</div>
              <SubscribeForm />
            </div>

          </div>

          {/* ── Row 2: 3 office columns ── */}
          <div className="ft__offices">
            {OFFICES.map(o => (
              <div key={o.label} className="ft__office">
                <div className="ft__office-label">{o.label}</div>
                <ul className="ft__office-list">
                  <li>
                    <IconMapPin />
                    <span>{o.address}</span>
                  </li>
                  <li>
                    <IconPhone />
                    <a href={`tel:${o.phone.replace(/\s/g,'')}`}>{o.phone}</a>
                  </li>
                  <li>
                    <IconMail />
                    <a href={`mailto:${o.email}`}>{o.email}</a>
                  </li>
                </ul>
              </div>
            ))}
          </div>

        </div>

        {/* Bottom bar */}
        <div className="ft__bottom">
          <span className="ft__copy">© {year} LJN Cruise &amp; Travel. All rights reserved.</span>
          <div className="ft__bottom-links">
            <a href={`${base}/privacy-policy`}>Privacy Policy</a>
            <a href={`${base}/terms`}>Terms &amp; Conditions</a>
          </div>
        </div>
      </footer>
    </>
  )
}
